/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_Reason_Not_StandingInputs */

const en_us2_body_assessment_pose_reason_not_standing = /** @type {(inputs: Body_Assessment_Pose_Reason_Not_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your body wasn't standing upright. Stand up straight, your whole body vertical.`)
};

const pt_br2_body_assessment_pose_reason_not_standing = /** @type {(inputs: Body_Assessment_Pose_Reason_Not_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O corpo não estava em pé. Fique em pé e reto, com o corpo inteiro na vertical.`)
};

const es_419_body_assessment_pose_reason_not_standing = /** @type {(inputs: Body_Assessment_Pose_Reason_Not_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuerpo no estaba de pie. Ponte de pie con el cuerpo recto, todo en vertical.`)
};

const pt_pt2_body_assessment_pose_reason_not_standing = /** @type {(inputs: Body_Assessment_Pose_Reason_Not_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O corpo não estava de pé. Fica de pé e direito, com o corpo inteiro na vertical.`)
};

const fr_fr2_body_assessment_pose_reason_not_standing = /** @type {(inputs: Body_Assessment_Pose_Reason_Not_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton corps n'était pas debout. Tiens-toi droit, le corps entier à la verticale.`)
};

const de_de2_body_assessment_pose_reason_not_standing = /** @type {(inputs: Body_Assessment_Pose_Reason_Not_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Körper stand nicht aufrecht. Steh gerade, der ganze Körper senkrecht.`)
};

const it_it2_body_assessment_pose_reason_not_standing = /** @type {(inputs: Body_Assessment_Pose_Reason_Not_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il corpo non era in piedi. Stai dritto, con tutto il corpo in verticale.`)
};

/**
* | output |
* | --- |
* | "Your body wasn't standing upright. Stand up straight, your whole body vertical." |
*
* @param {Body_Assessment_Pose_Reason_Not_StandingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_reason_not_standing = /** @type {((inputs?: Body_Assessment_Pose_Reason_Not_StandingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_Reason_Not_StandingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_reason_not_standing(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_reason_not_standing(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_reason_not_standing(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_reason_not_standing(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_reason_not_standing(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_reason_not_standing(inputs)
	return en_us2_body_assessment_pose_reason_not_standing(inputs)
});
export { body_assessment_pose_reason_not_standing as "body-assessment.pose_reason.not_standing" }